import { useLocation } from "react-router-dom";

export const useQueryParams = (key?: string) => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  if (key) {
    const value = params.get(key);
    return value && value.trim() !== '' ? value : undefined;
  }

  const allParams: Record<string, string> = {};
  params.forEach((value, paramKey) => {
    if (value.trim() !== '') {
      allParams[paramKey] = value;
    }
  });

  return allParams;
};
